<template>
    <div
        v-if="version"
        class="app-version"
    >
        {{ version }}
    </div>
</template>

<script>
export default {
    name: 'AppVersion',
    data() {
        return {
            version: '',
        };
    },
    async mounted() {
        try {
            const response = await this.$http.get('/version');
            const versionValue = typeof response.data === 'string'
                ? response.data
                : response.data?.version || response.data?.value || '';
            if (versionValue && versionValue.trim()) {
                this.version = versionValue.trim();
            }
        } catch (error) {
            // Игнорируем ошибки, версия не обязательна
        }
    },
};
</script>

<style scoped lang="scss">
.app-version {
    position: fixed;
    bottom: 20px;
    right: 20px;
    color: #fff;
    font-size: 12px;
    z-index: 1000;
}
</style>
